/**
 * Possible options when flipping a Font Awesome Icon
 */
export enum IconFlip {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Both = 'both',
  None = ''
}
